import React from 'react';
import { Button, ButtonGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faColumns } from '@fortawesome/free-solid-svg-icons';
import { TaskViewToggleProps } from '../types/types';

const TaskViewToggle: React.FC<TaskViewToggleProps> = ({ view, onChange }) => {
  return (
    <ButtonGroup>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-list">List View</Tooltip>}
      >
        <Button
          variant={view === 'list' ? 'primary' : 'outline-primary'}
          onClick={() => onChange('list')}
        >
          <FontAwesomeIcon icon={faList} />
        </Button>
      </OverlayTrigger>

      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-kanban">Kanban View</Tooltip>}
      >
        <Button
          variant={view === 'kanban' ? 'primary' : 'outline-primary'}
          onClick={() => onChange('kanban')}
        >
          <FontAwesomeIcon icon={faColumns} />
        </Button>
      </OverlayTrigger>
    </ButtonGroup>
  );
};

export default TaskViewToggle;
